import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入axios相关
import '@/router/request.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import audioService from './resource/sound/api';

Vue.prototype.$audio = audioService;
Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
